import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { emptyArray } from 'ui-components/default-props/empty';
import * as OrderActions from '../../../store/orders/orders.actions';
import Global from '../../../store/global-selectors';
import { mapDispatchToOnClick, mapStateToOpen } from './section-container-helper';
import { OrderDrawerSection } from '../../../enums/order-drawer-section';
import DeprecatedTagsComponent from '../../../components/orders-drawer/sections/tags';

const sectionId = OrderDrawerSection.tags;

const selectedTagSelector = createSelector(
  (tagIds) => tagIds,
  (_, tags) => tags,
  (tagIds, tags) => {
    if (tags.length > 0) {
      const tagsMap = tags.reduce((acc, tag) => {
        return {
          ...acc,
          [tag.tagId]: tag,
        };
      }, {});

      return tagIds
        .map((tagId) => tagsMap[tagId])
        .filter((tag) => tag)
        .sort((tagA, tagB) => tagA - tagB);
    }
    return emptyArray;
  },
);

const mapStatesToProps = (state, ownProps) => {
  const { tagIds } = ownProps;
  const tags = Global.selectSellerTags(state) || emptyArray;
  const selectedTags = tagIds ? selectedTagSelector(tagIds, tags) : emptyArray;
  return {
    tags,
    selectedTags,
    ...mapStateToOpen(state, sectionId),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addTag: (fulfillmentPlanId, tagId) => dispatch(OrderActions.addTagsToFulfillmentPlans([fulfillmentPlanId], [tagId])),
    removeTag: (fulfillmentPlanId, tagId) => dispatch(OrderActions.removeTagsFromFulfillmentPlans([fulfillmentPlanId], [tagId])),
    ...mapDispatchToOnClick(dispatch, sectionId),
  };
};

export const TagsSectionContainer = connect(mapStatesToProps, mapDispatchToProps);
export const Tags = TagsSectionContainer(DeprecatedTagsComponent);
